import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface ProductCardProps {
  title: string;
  description: string;
  href: string;
  imageSrc: string;
  imageAlt: string;
  external?: boolean;
  badge?: string;
  onClick?: (e: React.MouseEvent) => void;
}
export function ProductCard({
  title,
  description,
  href,
  imageSrc,
  imageAlt,
  external = false,
  badge,
  onClick
}: ProductCardProps) {
  return <a href={href} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} className="group block bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 overflow-hidden" onClick={onClick ? e => {
    e.preventDefault();
    onClick(e);
  } : undefined} data-id="element-215">
      <div className="p-6" data-id="element-216">
        {/* Product Image */}
        <div className="w-full h-40 bg-gray-50 rounded-md mb-4 flex items-center justify-center overflow-hidden" data-id="element-217">
          <img src={imageSrc} alt={imageAlt} className="block w-full h-full object-contain" data-id="element-218" />
        </div>

        {badge && <span className="inline-block px-3 py-1 text-xs font-semibold text-orange bg-orange/10 rounded-full mb-3" data-id="element-219">
            {badge}
          </span>}

        <h3 className="text-lg font-semibold text-navy mb-2 group-hover:text-orange transition-colors" data-id="element-220">
          {title}
        </h3>

        <p className="text-gray-600 text-sm mb-4 line-clamp-2" data-id="element-221">{description}</p>

        <div className="flex items-center text-orange font-medium text-sm group-hover:gap-2 transition-all" data-id="element-222">
          <span data-id="element-223">Learn More</span>
          <ArrowRightIcon className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" data-id="element-224" />
        </div>
      </div>
    </a>;
}